import { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import Loader from '../components/Loader';
import { SubjectsContext } from '../globalContext/subjects/subjectsProvider';
import { SubscriptionContext } from '../globalContext/subscriptions/subscriptionsProvider';
import useHasAsyncSatAccess from '../hooks/useHasAsyncSatAccess';
import { ROUTES } from '../route/routes';

function withAsyncSatAccess(Component: React.FC) {
  return (props: any) => {
    const [subjectInfo] = useContext(SubjectsContext);
    const [subscriptionInfo] = useContext(SubscriptionContext);
    const hasAsyncSatAccess = useHasAsyncSatAccess();

    // Subjects are only fetched for paid / IC3 users, so wait for them before deciding.
    const isAwaitingSubjects =
      !subjectInfo?.allSubjectsList &&
      Boolean(subscriptionInfo?.subscription?.paid || subscriptionInfo?.subscription?.has_ic3_subscription);

    if (isAwaitingSubjects) {
      return <Loader />;
    }

    if (!hasAsyncSatAccess) {
      return <Navigate to={ROUTES.DASHBOARD} replace />;
    }

    return <Component {...props} />;
  };
}

export default withAsyncSatAccess;
